import axios from 'axios';
import { useMutation } from 'react-query';
import Cookies from 'js-cookie';
import { useQueryPersonalCreditSolicitations } from './useQueryPersonalCreditSolicitations';
import { useQueryPersonalDashboard } from './useQueryPersonalDashboard';
import { useSnackbar } from 'hooks/UseSnackbar';
import { useTranslation } from 'react-i18next';
import { valueToMoneyFloat } from 'utils/general/valueToMoneyFloat';
import { moneyMask } from 'utils/masks/moneyMask';
import { getQuotaManagersAndSendEmails } from 'services/Emails/Quota/quotaEmailService';

export const useMutationCreateCreditRequest = setOpen => {
    const toast = useSnackbar();
    const [t] = useTranslation();

    if (localStorage.getItem('auth-token') !== null) {
        var auth = JSON.parse(localStorage.getItem('auth-token'));
    }

    const queryDashboard = useQueryPersonalDashboard(
        { enabled: false },
        auth.id
    );
    const queryPersonalCreditSolicitations =
        useQueryPersonalCreditSolicitations({ enabled: false }, auth.id);

    const mutation = useMutation({
        mutationFn: async obj =>
            await axios.post(
                process.env.REACT_APP_SERVER +
                    `api/Quota/CreditSolicitations/User/${auth.id}`,
                obj,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            ),
        onSuccess: res => {
            toast.success(t('QUOTAS.creditRequestCreated'));
            const data = res.data;

            const emailData = {
                collaboratorName: data.user.shortname,
                collaboratorEmail: data.user.username,
                value: `R$ ${moneyMask(valueToMoneyFloat(data.value))}`
            };

            getQuotaManagersAndSendEmails(
                emailData,
                'api/Quota/CreditSolicitation/New',
                'QUOTAS_CREDIT_SOLICITATION_EMAIL_OPTIONAL'
            );
        },
        onError: () => {
            toast.error(t('QUOTAS.creditRequestCreatedError'));
        },
        onSettled: () => {
            setOpen(false);
            queryDashboard.refetch();
            queryPersonalCreditSolicitations.refetch();
        }
    });

    return mutation;
};
